module.exports = {"meta":{"ajaxType":"post","path":"/wantwant-server/kayzsale/list","type":"report","id":"sales_list","code":"sales_list","title":"KA银座销售表","buttons":[],"columns":[{"name":"accountId","title":"账户ID"},{"name":"billDate","title":"销售日期"},{"name":"downloadTime","title":"数据采集日期"},{"name":"id","title":"主键ID"},{"name":"prodBrand","title":"品牌"},{"name":"prodCode","title":"商品编号"},{"name":"prodQuantity","title":"销售数量"},{"name":"storeName","title":"门店名称"},{"name":"updatedTime","title":"修改日期"}],"params":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/views/sales/kayzsale.json
// module id = xlCz
// module chunks = 63